import useAct from 'Workflows/hooks/useAct'
import EditBranch from 'Workflows/components/Builder/Forms/EditBranch'
import Button from 'Shared/components/Button'

export default function BranchSidebar() {
  const act = useAct()
  const { nodeId, branchId } = useSel(s => s.local.sidebar)
  const state = useSel(s => s.builder.workflow.state)
  const properties = useSel(s => s.workflowNodes.entities[nodeId].properties.branches.find(b => b.branchId === branchId))

  if (!properties) return null
  const canDelete = !properties['workflowNodeId'] && (state === 'draft' || state === 'paused')

  const handleDelete = () => {
    return act.local.openModal({ kind: 'deleteBranchConfirm', nodeId, branchId })
  }

  const editRules = () => {
    act.local.editBranchRules({ nodeId, branchId })
  }

  const readOnly = !(state === 'draft' || state === 'paused')

  return <div className='box workflow-sidebar'>
    <h3 className='no-margin-top'>Branch</h3>
    <EditBranch nodeId={nodeId} branchId={branchId} key={`${nodeId}-${branchId}`} />
    <div className='divider margin-top' />
    <div className='margin-top'>
      <Button secondary small onClick={editRules}>Edit rules</Button>
    </div>
    { !readOnly && <>
      { canDelete && <div className='margin-top'>
        <Button extraClass='red-outline' small onClick={handleDelete}>Delete</Button>
      </div> }
      { !canDelete && <div className='margin-top'>
        <span className='dark-grey'>You can only delete a branch with no nodes</span>
      </div> }
    </> }
  </div>
}
